/* eslint-disable react/prop-types */
import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import PartyService from "../../service/party-service";

const partyService = new PartyService();

await loadDictionary('party-create-window');

function CreatePartyWindow({isOpenWindow, onCloseWindow}) {
  const [name, setName] = useState('');
  const [accountingNumber, setAccountingNumber] = useState('');
  
  const handleClose = () => {
    setName('');
    setAccountingNumber('');
    onCloseWindow();
  };
  
  const handleSubmit = () => {
    const party = {
      name: name,
      accounting_number: accountingNumber
    };

    partyService.create(party).then(result => {
      if(result) {
        handleClose();
      }
    }).catch(error => {
      console.error(error);
    })
  }

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("party-create-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="CreateForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("party-create-window.name")}</Form.Label>
            <Form.Control type="text" autoFocus value={name} onChange={e => {setName(e.target.value)}}></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("party-create-window.accounting_number")}</Form.Label>
            <Form.Control type="text" dir="ltr" value={accountingNumber} onChange={e => {setAccountingNumber(e.target.value)}}></Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("party-create-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="CreateForm" >{i18n.t("party-create-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreatePartyWindow;